import { Link } from 'react-router-dom'

import { cn } from '@/lib/utils'

interface AuthFormLink {
  to: string
  text: string
  className?: string
}

interface AuthFormFooterProps {
  links: AuthFormLink[]
  text?: string
  className?: string
  textClassName?: string
  linkClassName?: string
  ns?: string
  divider?: string
}

export const AuthFormFooter = ({ links, text, className = '', linkClassName = '' }: AuthFormFooterProps) => {
  return (
    <div className={cn('flex flex-wrap items-center justify-center gap-2 text-sm', className)}>
      <span>{text}</span>
      {links.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={cn('hover:text-primary underline underline-offset-4', linkClassName)}
        >
          {link.text}
        </Link>
      ))}
    </div>
  )
}
